import React from "react";
import PdfContractViewer from "@/components/ContractViewer/ContractViewer";

const ContractView = (): JSX.Element => {
    return <PdfContractViewer />;
};

export default ContractView;
